var _g, _path, _path2, _path3, _path4, _g2, _path5, _path6, _path7, _g3, _path8, _path9, _path0, _g4, _path1, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpEngagements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13506_34418)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5,
    width: 40,
    height: 40,
    rx: 5,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 5.5,
    width: 39,
    height: 39,
    rx: 4.5,
    stroke: "#06513D",
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9033 17.7705C27.1658 17.7705 27.3789 17.9836 27.3789 18.2461V20.4287C27.2108 20.3929 27.0402 20.3712 26.8701 20.3662H26.8613L26.4326 20.3584V18.2461C26.4326 17.9803 26.6443 17.7706 26.9033 17.7705Z",
    fill: "#06513D",
    stroke: "#06513D",
    strokeWidth: 1.33333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4902 18.3398C23.7525 18.34 23.9658 18.5531 23.9658 18.8154V20.3135L23.0146 20.2949V18.8154C23.0146 18.5546 23.2305 18.3398 23.4902 18.3398Z",
    fill: "#06513D",
    stroke: "#06513D",
    strokeWidth: 1.33333
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3184 18.3398C30.5807 18.34 30.7939 18.5531 30.7939 18.8154V22.4316C30.7938 22.6939 30.5806 22.907 30.3184 22.9072C30.0454 22.9072 29.8428 22.7007 29.8428 22.4355V18.8154C29.8428 18.553 30.0559 18.3398 30.3184 18.3398Z",
    fill: "#06513D",
    stroke: "#06513D",
    strokeWidth: 1.33333
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13506_34418",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 21,
    width: 18,
    height: 20
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4326 21.7119V39.6328H19.8311V21.7119H35.4326Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.33333
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13506_34418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7793 22.7676H22.7842L26.7959 22.8457V22.8467C27.05 22.8542 27.251 23.0673 27.251 23.3047C27.2509 23.4304 27.2017 23.5394 27.1133 23.6211L27.1025 23.6309L27.0938 23.6406C27.0356 23.6988 26.9219 23.7562 26.7559 23.7568L24.0137 23.6348H23.9736C23.3685 23.6437 22.8416 24.0575 22.7432 24.6777L22.7422 24.6816L22.4736 26.4404L22.4727 26.4473C22.3755 27.1275 22.8518 27.7419 23.5156 27.8447L23.5312 27.8467C24.1615 27.9289 24.8161 27.5088 24.915 26.8145L24.916 26.8154L24.9531 26.5703C25.847 27.1426 26.2764 27.8882 26.4873 28.5303C26.7454 29.3163 26.6755 29.9463 26.6846 29.8828L26.6826 29.8965L26.6807 29.9111C26.6128 30.5914 27.1139 31.186 27.7754 31.2617L27.8135 31.2656H27.9131C28.5577 31.2656 29.0747 30.7791 29.1406 30.1572V30.1543C29.2523 29.0545 28.9745 27.4161 27.9111 26.001C28.2423 25.8637 28.5486 25.664 28.8174 25.4092L28.8184 25.4102C28.9176 25.3173 29.0067 25.2146 29.0898 25.1045C29.474 25.2835 29.8907 25.3779 30.3164 25.3779C31.0935 25.3779 31.8134 25.0707 32.3555 24.5391C32.9909 24.8851 33.7239 24.9796 34.4336 24.8027C34.6689 26.416 34.786 28.2693 34.7705 30.3311C34.7555 31.615 34.0941 32.7932 32.9824 33.4805L32.9746 33.4854L32.2559 33.9443V33.9453C31.8813 34.1744 31.6827 34.5759 31.6826 34.9824V39.8994H25.3604V35.1367C25.3603 34.8437 25.2612 34.546 25.0498 34.3135L21.8945 30.7354L21.8936 30.7344L21.7471 30.5605C21.0418 29.6728 20.719 28.5263 20.8652 27.3818L21.3018 24.0322C21.3975 23.3185 22.0239 22.7678 22.7793 22.7676Z",
    fill: "#06513D",
    stroke: "#06513D",
    strokeWidth: 1.33333
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7363 18.8291C33.9959 18.8293 34.207 19.0392 34.207 19.2998V21.9502C34.207 22.2142 33.9925 22.4256 33.7363 22.4258C33.4739 22.4258 33.2607 22.2127 33.2607 21.9502V19.2998C33.2608 19.0303 33.459 18.8291 33.7363 18.8291Z",
    fill: "#06513D",
    stroke: "#06513D",
    strokeWidth: 1.33333
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5605 30.8164C17.6485 30.7659 17.7534 30.7973 17.8027 30.8789C17.8526 30.9689 17.8224 31.0733 17.7412 31.1221L14.9678 32.7246C14.9286 32.7468 14.8957 32.7528 14.8779 32.7529C14.814 32.7529 14.7555 32.7203 14.7236 32.665L14.7227 32.6631C14.6723 32.575 14.702 32.4717 14.7832 32.4229L17.5615 30.8174L17.5605 30.8164Z",
    fill: "#06513D",
    stroke: "#06513D",
    strokeWidth: 1.33333
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_13506_34418",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 23,
    width: 5,
    height: 4
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2373 23.9717V26.0254H12.667V23.9717H16.2373Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.33333
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_13506_34418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8467 24.8203H16.0566C16.1515 24.8203 16.2324 24.9012 16.2324 24.9961V25.002C16.2333 25.0906 16.1617 25.1709 16.0566 25.1709H12.8467C12.7497 25.1709 12.6711 25.0929 12.6709 24.9961C12.6709 24.9012 12.7518 24.8203 12.8467 24.8203Z",
    fill: "#06513D",
    stroke: "#06513D",
    strokeWidth: 1.33333
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9707 17.2637L17.7451 18.8672L17.751 18.8701C17.8277 18.9137 17.8617 19.0165 17.8096 19.1074L17.8066 19.1133C17.7765 19.1664 17.7223 19.1973 17.6592 19.1973C17.6309 19.1972 17.6019 19.1906 17.5713 19.1729L17.5693 19.1719L14.791 17.5713C14.7278 17.5348 14.6939 17.4648 14.7031 17.3945L14.7266 17.3262C14.7711 17.2495 14.8809 17.2141 14.9707 17.2637Z",
    fill: "#06513D",
    stroke: "#06513D",
    strokeWidth: 1.33333
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.335 11.7178C20.4244 11.6686 20.5291 11.6991 20.5781 11.7842V11.7852L22.1836 14.5635L22.1846 14.5654C22.2319 14.6467 22.2056 14.753 22.1191 14.8027C22.0925 14.8169 22.0626 14.8242 22.0332 14.8242C21.9623 14.8241 21.9084 14.7899 21.8799 14.7402L21.8789 14.7383L20.2734 11.96C20.2233 11.8719 20.2531 11.7668 20.335 11.7178Z",
    fill: "#06513D",
    stroke: "#06513D",
    strokeWidth: 1.33333
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_13506_34418",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 9,
    width: 3,
    height: 6
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6543 9.66699V13.6035H27.7295V9.66699H28.6543Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.33333
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_13506_34418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.999 9.66699C28.096 9.66723 28.1738 9.7459 28.1738 9.84277V13.0488C28.1737 13.1456 28.0959 13.2244 27.999 13.2246C27.8998 13.2246 27.8234 13.148 27.8232 13.0488V9.84277C27.8232 9.74349 27.8997 9.66699 27.999 9.66699Z",
    fill: "#06513D",
    stroke: "#06513D",
    strokeWidth: 1.33333
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6699 11.7148L35.6719 11.7158C35.7517 11.7614 35.7835 11.8691 35.7334 11.9561L34.1318 14.7324C34.0969 14.7915 34.0367 14.8232 33.9736 14.8232C33.9453 14.8232 33.9155 14.8166 33.8848 14.7988C33.8194 14.76 33.7881 14.6904 33.7969 14.623L33.8193 14.5576L35.4248 11.7793L35.4238 11.7783C35.4752 11.6935 35.5858 11.6665 35.6699 11.7148Z",
    fill: "#06513D",
    stroke: "#06513D",
    strokeWidth: 1.33333
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.04 17.2637C41.1162 17.2195 41.2247 17.2417 41.2773 17.3281V17.3291C41.3262 17.4141 41.2969 17.5246 41.21 17.5752L38.4395 19.1768C38.4117 19.1925 38.3796 19.2002 38.3486 19.2002C38.2778 19.2001 38.2238 19.1658 38.1953 19.1162L38.1943 19.1152C38.1459 19.031 38.1738 18.9214 38.2588 18.8701L41.0371 17.2646L41.04 17.2637Z",
    fill: "#06513D",
    stroke: "#06513D",
    strokeWidth: 1.33333
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9521 24.8223H43.1621C43.2524 24.8223 43.334 24.8986 43.334 24.998C43.3338 25.0994 43.2546 25.1729 43.1621 25.1729H39.9521C39.853 25.1729 39.7766 25.0971 39.7764 24.998C39.7764 24.9009 39.8551 24.8223 39.9521 24.8223Z",
    fill: "#06513D",
    stroke: "#06513D",
    strokeWidth: 1.33333
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4326 30.8164L38.4355 30.8174L41.2139 32.4189C41.3001 32.4689 41.3279 32.5778 41.2803 32.6611L41.2793 32.6641C41.2478 32.7198 41.1872 32.7529 41.127 32.7529C41.1092 32.7528 41.0763 32.7468 41.0371 32.7246L38.2588 31.1221C38.1725 31.0701 38.1469 30.9646 38.1943 30.8818C38.2441 30.7954 38.3513 30.769 38.4326 30.8164Z",
    fill: "#06513D",
    stroke: "#06513D",
    strokeWidth: 1.33333
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13506_34418",
    x: 0.8,
    y: 0.8,
    width: 52.4,
    height: 52.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.529412 0 0 0 0 0.639216 0 0 0 0.52 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13506_34418"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13506_34418",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpEngagements);
export default __webpack_public_path__ + "static/media/EmpEngagements.44e8e5790d4fa13f25eae2b67367affc.svg";
export { ForwardRef as ReactComponent };